import {
  Center,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { DateDisplay } from './Date';

type DateEntry = { label: string; value: Date | string | undefined };

export interface DateStackProps {
  dates: DateEntry[];
}

export const DateStack = (props: DateStackProps) => {
  const { dates } = props;

  return (
    <TableContainer>
      <Table variant="simple" size="md">
        <Thead>
          <Tr>
            <Th>Type</Th>
            <Th>Date</Th>
          </Tr>
        </Thead>
        <Tbody>
          {!dates.length && (
            <Tr>
              <Td colSpan={2}>
                <Center>No Dates to Display</Center>
              </Td>
            </Tr>
          )}
          {dates.map((d, i) => (
            <Tr key={i}>
              <Td>{d.label}</Td>
              <Td>
                <DateDisplay value={d.value} />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export interface EntityDateStackProps {
  dates?: { label: string; date: Date | string }[];
  entity: {
    created: Date;
    updated: Date;
  };
}
